var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurity1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8336,
    y1: 230.513,
    x2: 254.8336,
    y2: -93.917,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FFBF5C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "436.758,233.731 436.758,512 75.292,512 75.292,233.731 256.025,51.904 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.0676,
    y1: 306.632,
    x2: 99.7177,
    y2: 421.982,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    points: "436.758,233.731 436.758,512 322.632,512 75.292,264.66 75.292,233.731  256.025,51.904 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.6317,
    y1: 247.5261,
    x2: 200.5217,
    y2: 420.626,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M163.751,144.737c5.765,12.36,13.92,23.38,23.902,32.435l249.104,249.105V233.731 L256.025,51.904L163.751,144.737z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.9995,
    y1: 235.8038,
    x2: 104.5295,
    y2: 419.2738,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M436.763,307.11L265.574,135.921c-1.489-3.84-5.209-6.566-9.574-6.566 c-5.675,0-10.276,4.601-10.276,10.276v3.112c-2.325,1.123-4.513,2.624-6.441,4.553l-94.684,94.684 c-4.088,4.087-4.013,10.761,0.227,14.753l256.402,255.261h35.536L436.763,307.11L436.763,307.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.2472,
    y1: 77.8516,
    x2: 55.8172,
    y2: 240.2816,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M380.902,512H204.123l-97.176-97.176c-4.278-2.773-7.126-7.586-7.126-13.045v-78.211 c0-8.568,6.976-15.545,15.545-15.545h56.385c5.471,0,10.284,2.848,13.058,7.126l-0.423,0.336L380.902,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M171.753,408.211h-56.38c-3.556,0-6.438-2.882-6.438-6.438v-78.198c0-3.556,2.882-6.438,6.438-6.438 h56.38c3.556,0,6.438,2.882,6.438,6.438v78.198C178.191,405.328,175.309,408.211,171.753,408.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.754,417.323h-56.38c-8.574,0-15.55-6.975-15.55-15.55v-78.199c0-8.574,6.975-15.55,15.55-15.55 h56.38c8.574,0,15.55,6.975,15.55,15.55v78.199C187.304,410.348,180.328,417.323,171.754,417.323z M118.048,399.098h51.03v-72.849 h-51.03V399.098z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.3061,
    y1: 109.9905,
    x2: 308.3061,
    y2: 213.9905,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M436.764,340.283V512h-5.547l-97.176-97.176c-4.291-2.773-7.138-7.586-7.138-13.045v-78.211 c0-8.568,6.976-15.545,15.558-15.545h56.372c5.472,0,10.284,2.848,13.058,7.126l0.224,0.174l-0.15,0.162L436.764,340.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M398.839,408.211h-56.38c-3.556,0-6.438-2.882-6.438-6.438v-78.198c0-3.556,2.882-6.438,6.438-6.438 h56.38c3.556,0,6.438,2.882,6.438,6.438v78.198C405.276,405.328,402.394,408.211,398.839,408.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.839,417.323h-56.38c-8.574,0-15.55-6.975-15.55-15.55v-78.199c0-8.574,6.975-15.55,15.55-15.55 h56.38c8.575,0,15.55,6.975,15.55,15.55v78.199C414.389,410.348,407.414,417.323,398.839,417.323z M345.133,399.098h51.03v-72.849 h-51.03V399.098z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.7347,
    y1: 254.2897,
    x2: 181.7428,
    y2: 71.9697,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#816965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#654E48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M477.629,258.869L266.902,48.074c-6.006-6.006-15.745-6.006-21.751,0L34.371,258.852 c-3.929,3.929-3.929,10.3,0,14.23l8.983,8.983c3.929,3.929,10.3,3.929,14.23,0L253.163,86.488c1.581-1.581,4.145-1.581,5.726,0 l195.526,195.594c3.929,3.929,10.3,3.929,14.23,0l8.983-8.983C481.558,269.169,481.558,262.799,477.629,258.869z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.8955,
    y1: 301.4899,
    x2: 328.6255,
    y2: 379.7498,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M266.902,48.074c-3.004-3.004-6.939-4.505-10.875-4.505v41.733 c1.036,0,2.072,0.396,2.863,1.186l195.526,195.594c3.929,3.929,10.3,3.929,14.23,0l8.983-8.983c3.929-3.929,3.929-10.3,0-14.23 L266.902,48.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#816965"
    },
    d: "M218.36,511.995v-175.57c0-20.802,16.864-37.665,37.665-37.665l0,0 c20.802,0,37.665,16.864,37.665,37.665v175.57H218.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503837"
    },
    d: "M303.019,511.995h-18.654V336.212c0-15.469-12.656-28.126-28.126-28.126h-0.425 c-15.534,0-28.126,12.592-28.126,28.126v175.782h-18.654V336.425c0-25.953,21.039-46.993,46.993-46.993l0,0 c25.953,0,46.993,21.039,46.993,46.993L303.019,511.995L303.019,511.995z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 242.658,
    cy: 372.877,
    r: 8.505
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.8007,
    y1: 29.3285,
    x2: 434.8607,
    y2: 29.3285,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#816965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#654E48"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 75.286,
    y: 462.236,
    style: {
      fill: "url(#SVGID_9_)"
    },
    width: 361.472,
    height: 49.763
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.181,
    y1: 56.8553,
    x2: 119.471,
    y2: -8.4247,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M137.66,492.55c0,6.868-1.299,13.421-3.67,19.445H35.095 c-2.371-6.024-3.67-12.577-3.67-19.445c0-6.687,1.233-13.08,3.491-18.97c7.636-19.976,26.976-34.147,49.627-34.147 s41.991,14.171,49.627,34.147C136.427,479.47,137.66,485.863,137.66,492.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.0217,
    y1: 42.4961,
    x2: 158.3817,
    y2: -4.8639,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M171.912,497.889c0,4.981-0.943,9.736-2.662,14.105H97.511 c-1.72-4.369-2.662-9.124-2.662-14.105c0-4.851,0.894-9.488,2.532-13.762c5.539-14.491,19.568-24.771,36-24.771 s30.461,10.28,36,24.771C171.017,488.401,171.912,493.039,171.912,497.889z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#503837"
    },
    points: "169.678,235.545 256,149.223 342.322,235.545 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.2601,
    y1: 366.9944,
    x2: 154.2681,
    y2: 484.3744,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#816965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#654E48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M256,247.192c-5.675,0-10.276-4.601-10.276-10.276v-97.284 c0-5.675,4.601-10.276,10.276-10.276c5.675,0,10.276,4.601,10.276,10.276v97.284C266.276,242.591,261.675,247.192,256,247.192z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.8963,
    y1: 230.7871,
    x2: 14.9043,
    y2: 210.3071,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#816965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#654E48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M166.937,229.379h178.126c5.675,0,10.276,4.601,10.276,10.276s-4.601,10.276-10.276,10.276 H166.937c-5.675,0-10.276-4.601-10.276-10.276S161.262,229.379,166.937,229.379z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.0723,
    y1: 340.2381,
    x2: 133.0803,
    y2: 458.9281,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#816965"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#654E48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M360.135,259.524c-2.63,0-5.26-1.004-7.266-3.01l-88.988-88.988 c-4.352-4.352-11.409-4.352-15.762,0l-88.682,88.682c-3.979,3.979-10.515,4.383-14.611,0.526 c-4.239-3.992-4.315-10.666-0.227-14.753l94.684-94.684c9.233-9.233,24.203-9.233,33.435,0l94.684,94.684 c4.014,4.013,4.014,10.52,0,14.533C365.395,258.52,362.765,259.524,360.135,259.524z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8733,
    y1: 300.364,
    x2: 15.1733,
    y2: 416.7141,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M367.397,256.509c-2.001,2.014-4.631,3.015-7.262,3.015c-2.63,0-5.262-1-7.262-3.015 l-86.596-86.583v-27.212c2.329,1.123,4.508,2.644,6.44,4.577l94.681,94.694C371.412,246,371.412,252.494,367.397,256.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0495,
    y1: 65.5239,
    x2: 458.1495,
    y2: -10.5761,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M480.575,489.328c0,8.005-1.515,15.645-4.279,22.667H361.018 c-2.764-7.021-4.279-14.661-4.279-22.667c0-7.795,1.438-15.248,4.069-22.113c8.901-23.286,31.446-39.804,57.849-39.804 c26.404,0,48.948,16.519,57.849,39.804C479.139,474.081,480.575,481.533,480.575,489.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.5064,
    y1: 249.2607,
    x2: 235.2764,
    y2: 349.4907,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#654E48",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#503837"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M272.717,147.296c-1.929-1.929-4.116-3.43-6.441-4.553v-3.112 c0-5.675-4.601-10.276-10.276-10.276c-5.675,0-10.276,4.601-10.276,10.276v3.112c-2.325,1.123-4.513,2.624-6.441,4.553 l-40.752,40.752l14.533,14.533l32.661-32.661v59.457h-5.863l20.553,20.553h84.649c0.392,0,0.776-0.026,1.156-0.069l6.65,6.65 c2.007,2.007,4.636,3.01,7.266,3.01s5.26-1.004,7.266-3.01c4.014-4.013,4.014-10.52,0-14.533L272.717,147.296z M266.276,229.379 v-59.457l59.457,59.457H266.276z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.8186,
    y1: 459.163,
    x2: 363.8487,
    y2: 304.133,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF931E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5D00"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    cx: 256,
    cy: 101.768,
    r: 101.768
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.6029,
    y1: 338.6102,
    x2: 198.8529,
    y2: 463.3602,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M357.366,110.792L285.046,38.47c-7.345-7.984-17.87-12.998-29.547-12.998 c-22.142,0-40.157,18.014-40.157,40.157v9.393c-4.865,3.389-8.054,9.016-8.054,15.394v58.849c0,5.789,2.625,10.961,6.745,14.402 l39.843,39.843c0.707,0.015,1.415,0.027,2.125,0.027C309.165,203.538,352.799,162.77,357.366,110.792z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8097,
    y1: 451.333,
    x2: 254.8097,
    y2: 313.653,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2EDF2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M295.655,74.383v-8.753c0-22.142-18.014-40.157-40.157-40.157 c-22.142,0-40.157,18.014-40.157,40.157v9.393c-4.865,3.389-8.054,9.016-8.054,15.394v58.849c0,10.36,8.399,18.76,18.76,18.76 h59.908c10.36,0,18.76-8.399,18.76-18.76V90.417C304.713,83.612,301.078,77.671,295.655,74.383z M263.529,120.729v19.693 c0,4.158-3.37,7.529-7.529,7.529c-4.159,0-7.529-3.371-7.529-7.529v-19.693c-5.719-2.794-9.669-8.65-9.669-15.444 c0-9.498,7.7-17.198,17.198-17.198c9.498,0,17.198,7.7,17.198,17.198C273.198,112.079,269.249,117.935,263.529,120.729z  M280.596,71.657H230.4v-6.028c0-13.839,11.259-25.098,25.098-25.098c13.839,0,25.098,11.259,25.098,25.098V71.657z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity1);
export default __webpack_public_path__ + "static/media/icon-security-1.e6755b77b48a0c1ac69b31d3083380b9.svg";
export { ForwardRef as ReactComponent };